import { ReportMetric } from "../Components/index";

export default ReportMetric;
